<form [formGroup]="viewFormGroup">
  <div class="row-wrapper">
    <h3>Update Field</h3>
    <input type="text" formControlName="fieldName" [placeholder]="'Update field'" />
    <mat-select placeholder="field type" formControlName="targetType">
      @for (targetType of targetTypeOptions; track targetType) {
        <mat-option
          [value]="targetType"
          [matTooltip]="targetType | titlecase"
          matTooltipShowDelay="500"
          matTooltipClass="tooltip-no-truncate"
          matTooltipPosition="after"
          >
          {{ targetType }}
        </mat-option>
      }
    </mat-select>
    <mat-select placeholder="with" formControlName="actionType" (selectionChange)="updateActionType($event)">
      @for (actionType of actionTypeOptions; track actionType) {
        <mat-option
          [value]="actionType.type"
          [matTooltip]="actionType.label"
          matTooltipShowDelay="500"
          matTooltipClass="tooltip-no-truncate"
          matTooltipPosition="after"
          >
          {{ actionType.label }}
        </mat-option>
      }
    </mat-select>
    @if (!hideViewValueOption) {
      <input type="text" formControlName="viewValue" [placeholder]="'Value'" />
    }
    <mat-icon
      class="remove"
      fontIcon="close"
      [matTooltip]="'Remove action'"
      matTooltipShowDelay="500"
      (click)="removeAction()"
      (keydown.enter)="removeAction()"
      (keydown.space)="removeAction()"
      tabindex="0"
      >
    </mat-icon>
  </div>
</form>
